<template>
    <div class="hero-subsidy theme--dark" :class="status ? `hero-subsidy--${status}` : ''">
        <div>
            <a href="#content" class="button--gesture">
                <div />
                <div class="sr-only">{{ t('skiplinks.content') }}</div>
                <BaseIcon icon="arrow-down-long" />
            </a>
            <BackLink class="hero-subsidy__backlink">
                <NuxtLink :to="localePath(`/${backlinkUri}`)">
                    <div class="sr-only">{{ t('a11y.return-to') }}</div>
                    <BaseIcon icon="chevron-left" />
                    {{ t('subsidies.backlink') }}
                </NuxtLink>
            </BackLink>
            <h1 class="hero-subsidy__title">{{ title }}</h1>
            <div class="hero-subsidy__sub-header">
                <BaseTag :text="t('subsidy_hero.subsidy_tag')" />
                <SubsidyStatus class="hero-subsidy__status" :subsidy-periods="periodsRelation" @status="onStatus" />
            </div>
            <div class="hero-subsidy__content">
                <p v-if="description" class="hero-subsidy__description">{{ description }}</p>

                <BaseGrid class="hero-subsidy__help-cards" stretch>
                    <HelpCard
                        v-for="(card, i) in helpCards"
                        :key="i"
                        :label="card?.title"
                        :description="card?.description"
                        :link="card?.link?.[0]"
                        :icon="card?.icon"
                        :is-last-updated-relevant="card?.isLastUpdatedRelevant"
                        :last-updated="card?.dateUpdated"
                        :uri="card?.uri"
                        :external-url="card?.externalUrl"
                    />
                </BaseGrid>
            </div>
        </div>
    </div>
</template>

<script setup>
const { t, locale } = useI18n();
const localePath = useLocalePath();
const status = ref(false);

defineProps({
    title: {
        type: String,
        required: true,
        default: null
    },
    description: {
        type: String,
        required: true,
        default: null
    },
    uri: {
        type: String,
        required: true,
        default: ''
    },
    periodsRelation: {
        type: Array,
        default() {
            return [];
        }
    },
    helpCards: {
        type: Array,
        default: () => []
    }
});

const backlinkUri = computed(() => {
    return locale.value === 'nl' ? 'subsidies' : 'funding';
});

const onStatus = (newStatus) => {
    status.value = newStatus;
};
</script>

<style lang="less" src="./HeroSubsidy.less"></style>
